import { getLocalizedStringValue } from '@griply/utils';
import { useMemo } from 'react';
import { useI18nLocale } from 'shared/lib/react-i18next/use-i18n-locale';
import { LocalizedGoalTemplateCategoryWithGoalTemplates } from 'shared/types/goal-template-category';

import { useGoalTemplateCategories } from './use-goal-template-categories';

export const useLocalizedGoalTemplateCategories = () => {
  const locale = useI18nLocale();
  const categories = useGoalTemplateCategories();

  return useMemo<LocalizedGoalTemplateCategoryWithGoalTemplates[]>(
    () =>
      categories.map((category) => ({
        ...category,
        name: getLocalizedStringValue(category.name, locale),
      })),
    [categories, locale],
  );
};
